import { restPostJson } from "@MyLib/System/Rest.js";
import { getEndpoint } from "../../context/AppContext.jsx";
import { createCard } from "../../context/SaveData.js";

export const exportMTGADeck = (buildDeck, buildCardDatas) => {
	const rows = [];
	for (const col of buildDeck.columns) {
		if (col.name?.startsWith("*")) {
			continue;
		}
		for (const card of col.cards) {
			const data = buildCardDatas.find(c => c.uuid === card.uuid);
			rows.push({
				num: card.num,
				name: data.mtgaName.split("//")[0].trim()
			});
		}
	}
	const text = rows
		.map((card) => `${card.num} ${card.name}`)
		.join("\r\n");
	const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
	const url = URL.createObjectURL(blob);
	const a = document.createElement('a');
	a.href = url;
	a.download = `${buildDeck.name}.txt`;
	a.click();
	URL.revokeObjectURL(url);
};

const open = () => {
	return new Promise((resolve, reject) => {
		const input = document.createElement('input');
		input.type = 'file';
		input.accept = '.txt';
		input.onchange = e => {
			const file = e.target.files[0];
			if (!file) {
				return;
			}
			const reader = new FileReader();
			reader.onload = e => {
				resolve(e.target.result);
			};
			reader.onerror = () => reject(new Error("ファイルの読み込みに失敗しました"));
			reader.readAsText(file);
		};
		input.oncancel = () => {
			resolve(null); // rejectではなくresolve(null)にすると、エラーにならずに「なし」として扱える
		};
		input.click();
	});
};

const parseDeckText = (text) => {
	// 空行でブロックに分割
	const blocks = text
		.replace(/^\uFEFF/, "")
		.trim()
		.split(/\r?\n\s*\r?\n/);

	const columns = blocks.map((block) => {
		const lines = block
			.split(/\r?\n/)
			.map((line) => line.trim())
			.filter(Boolean);

		// ブロックの先頭行が項目名
		const [columnName, ...cardLines] = lines;

		const cards = cardLines.map((line) => {
			const match = line.match(
				/^(\d+)\s+(.+)\s+\(([^()]+)\)\s+(\S+)$/
			);

			if (!match) {
				throw new Error(`カードの形式が正しくありません: ${line}`);
			}

			return {
				num: Number(match[1]),
				name: match[2],
				setCode: match[3],
				number: match[4],
			};
		});

		return {
			name: columnName,
			cards,
		};
	});

	return {
		columns,
	};
};

export const importMTGADeck = async (language) => {
	const data = await open();
	if (!data) {
		return;
	}

	const parsedData = parseDeckText(data);
	const cards = parsedData.columns.flatMap((column) => column.cards);

	try {
		const data = await restPostJson(`${getEndpoint()}/mtg-cards-uuids`, {
			data: cards,
			language: language
		});
		return data.map((item) => ({
				...createCard(),
				uuid: item.uuid,
				num: item.num,
				language: language
			})
		);
	} catch (err) {
		console.error(err);
	}
}
